// JavaScript Document
//components/signs/Sign.js
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { 
		//useHistory, 
		useParams 
} from 'react-router-dom';
import PropTypes from 'prop-types';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import SaveIcon from '@material-ui/icons/Save';
import ConfigStandard from '../configuration/standard/Config';
import Ph5Config from '../configuration/ph5/Config';
import Overview from './Overview';
import Details from './Details';
import Stats from './Stats';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
}));

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box>
          {children}
        </Box>
      )}
    </div>
  );
}//`

	  
TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};
	  
function a11yProps(index) {
  return {
    id: `scrollable-auto-tab-${index}`,
    'aria-controls': `scrollable-auto-tabpanel-${index}`,
  };
}

export default function Sign(props) {
	const classes = useStyles();
	const {handleSend, user} = props;
	const [loaded, setLoaded] = React.useState(false);

	const [changed, setChanged] = React.useState(false);
	const [saveLabel, setSaveLabel] = React.useState('Save Sign');
  	//const [force, setForce] = React.useState(false);
  	const {id, tab} = useParams();
  	const [sign, setSign] = React.useState({
		sign_type_obj:{},
		options:[],
		geo_location: '-117.8027955, 33.86.25262',
	});
	const tabs = ['overview', 'details', 'stats', 'configuration'];
	const [tabNum, setTabNum] = React.useState(tab ? tabs.indexOf(tab) : 0);

	React.useEffect(() => {
		if(!loaded){
			getSign();
		}
	   // eslint-disable-next-line react-hooks/exhaustive-deps
	});

	const getSign = () =>{
		setLoaded(true);
		handleSend({
			vso: 'sign',
			sign: id
		}, (data) => {
			setSign(data.sign);

		});
	}
	const handleChange = (event, newValue) => {
		
		setTabNum(newValue);
	};


	
	const handleChangeDetails = (newSign, hidesave) => {
		var csign = Object.assign({}, sign, newSign);
		console.log(csign);
		if(csign.id === sign.id && !hidesave){
			setChanged(true);
			setSign(csign);
		}
	}
	
	const renderConfig = () => {
		var errorMessage = "Please select a sign type to configure this sign."
		if(sign.sign_type_obj.class_code){
			errorMessage = (
				<span>
				Sign type configuration not suppported. Please use <a href="http://forteltraffic.com/admin.php?action=vso">VSO v1.0</a>
				</span>
			);
			if(sign.sign_type_obj.class_code === 'Ph4')
				return (
					<ConfigStandard 
						handleSend={handleSend}
						sign={sign}
						user={user}
						onChange={handleChangeDetails}
					/>
				);
			if(sign.sign_type_obj.class_code === 'Ph5')
				return (
					<Ph5Config
						handleSend={handleSend}
						sign={sign}
						user={user}
					/>
				);
		} else if(typeof sign.sign_type_obj === "object" && Object.keys(sign.sign_type_obj).length !== 0){
			errorMessage = "Please contact your administrator to enable configuration for this sign type."
		}
		return (
			<Box p={3}>
				<Typography>
					{errorMessage}
				</Typography>
			</Box>);
	}
	const saveButton = () => {
		if(changed){
			return (
				<Button 
					variant="contained" 
					color="primary" 
					onClick={handleSave} 
					endIcon={<SaveIcon />}
					disabled={saveLabel==='Saving' ? true : false}
				>
					{saveLabel}
				</Button>
			);
		}
		return '';
	}
	const handleSave = (e) => {
		setSaveLabel('Saving');
		console.log("Save button clicked!");
		const payload = {
			vso: 'sign',
			sign,
			subaction : 'save'
		};
		console.log('payoad', payload);
		handleSend(payload, (data) => {
			//console.log(data);
			setChanged(false);
			setSaveLabel('Save Sign');
			setSign(data.sign);
		});
	}

	

	return (
		<div className={classes.root}>
			<AppBar position="static" color="default">
				<Tabs
					value={tabNum}
					onChange={handleChange}
					indicatorColor="primary"
					textColor="primary"
					variant="scrollable"
					scrollButtons="auto"
					aria-label="sign tabs"
				>
					<Tab label="Overview" {...a11yProps(0)} />
					<Tab label="Details" {...a11yProps(1)} />
					<Tab label="Stats" {...a11yProps(2)} />
					<Tab label="Configuration" {...a11yProps(3)} />
				</Tabs>
				{saveButton()}
			</AppBar>
			<TabPanel value={tabNum} index={0}>
				<Box p={3}>
					<Overview sign={sign} handleSend={handleSend} user={user} onChange={handleChangeDetails} handleSave={handleSave} />
				</Box>
			</TabPanel>
			<TabPanel value={tabNum} index={1}>
				<Details sign={sign} handleSend={handleSend} user={user} onChange={handleChangeDetails} save={handleSave} />
			</TabPanel>
			<TabPanel value={tabNum} index={2}>
				<Box p={2}>
					<Stats sign={sign} handleSend={handleSend} user={user} />
				</Box>
			</TabPanel>
			<TabPanel value={tabNum} index={3}>
				{renderConfig()}
			</TabPanel>
		</div>
	);
}
